import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=34664d68&scoped=true&"
import script from "./ReferralCard.vue?vue&type=script&lang=js&"
export * from "./ReferralCard.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCard.vue?vue&type=style&index=0&id=34664d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34664d68",
  null
  
)

export default component.exports